import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import './PageShell.css';
import './NotFound.css';

export default function NotFound() {
  const { language } = useLanguage();
  const text = language === 'zh' ? {
    title: '页面找不到了',
    subtitle: '您访问的页面不存在或已被移动，试试其他入口吧。',
    home: '返回首页',
    tasks: '浏览需求',
  } : {
    title: 'Page not found',
    subtitle: 'The page does not exist or has moved. Try another entry point.',
    home: 'Back home',
    tasks: 'Browse requirements',
  };
  return (
    <div className="nf-page page-shell-page">
      <div className="nf-code">404</div>
      <h1>{text.title}</h1>
      <p>{text.subtitle}</p>
      <div className="nf-actions">
        <Link to="/" className="btn btn-primary">🏠 {text.home}</Link>
        <Link to="/tasks" className="btn btn-ghost">📋 {text.tasks}</Link>
      </div>
    </div>
  );
}
